import TopicList from '../components/TopicList';

export default function StepSelectTopics({
  loading,
  topics,
  selectedTopics,
  onChange,
  app,
}) {
  return (
    <div>
      <h4>Select Topic(s)</h4>
      <TopicList
        loading={loading}
        topics={topics}
        selectedTopics={selectedTopics}
        onChange={onChange}
        app={app}
      />
    </div>
  );
}
